"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PosBotApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var PosBotApi = /** @class */ (function () {
    function PosBotApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     *
     * @method GET undefined
     *
     */
    PosBotApi.prototype.PosBot = function () {
        return this.http
            .url("/api/PosBot")
            .support('GET');
    };
    PosBotApi.diOptions = di_1.default.options({
        name: "PosBotApi",
        scope: "Singleton"
    });
    return PosBotApi;
}());
exports.PosBotApi = PosBotApi;
exports.default = PosBotApi;
